const maxFilesPerNetwork = {
 facebook: 20,
 instagram: Infinity,
 linkedin: 20,
 google: 1,
 threads: 10,
 twitter: 4,
 tiktok: 1,
 youtube: 1,
 pinterest: 1,
 telegram: 0
};

const formDataDefault = {
    planifiedDate: {
        date: false,
        hours: false,
        timestamp: false
    },
    textContent: "",
    mentions: {},
    idMentionSelected : null,
    textComment: '',
    urlsTextContent:[],
    urlsTextContentHistory: new Set([]),
    files : [],
    formDataNetwork: {
        facebook: {
            snippet: {
                link: '',
                title: "",
                description: "",
                imageUrl:""
            },
            typeMedia : 'image',
            place : null,
        },
        instagram: {
            personsIdentified : [],
            collaborators : [],
            music : null,
            place : null,
            ratio : "1:1",
            shareInStory: false
        },
        linkedin: {
            typeMedia : 'image',
            survey : {
                active : false,
                duration: 'threeDay',
                question : 'Aimes-tu les chats ?',
                options : ['Oui','Non']
            },
            pdf : {
                title : ''
            },
            snippet: {
                link: '',
                title: '',
                imageUrl: ''
            },
        },
        threads: {
            snippet: {
                link: '',
                imageUrl: ''
            },
        },
        twitter: {
            typeContent : 'image',
            snippet: {
                link: '',
            },
        },
        tiktok: {
            visibility : 'all',
            commentDisable: false,
            useVideoForDuo: true,
            useVideoForOtherVideo: true
        },
        google: {
            snippet: {
                link: '',
            },
        },
        telegram: {},
        pinterest: {
            snippet: {
                link: '',
            },
            boardSelectedByPage : {}
        },
        youtube: {
            visibility : 'all',
            category : "22",
            notifySubscribers: true,
            contentForChildren: false,
            tags : [],
            playlistSelectedByPage : {}
        }
    },
    storification : {
        '0' : {
            hide: false,
            background : {
                // file : {
                //     id: 1234567890,
                //     type:'image/jpeg',
                //     name:'imageDefault',
                //     size: 0,
                //     url : 'https://i.pinimg.com/236x/84/bd/bc/84bdbc1507a0697fe9288477342b2005.jpg', //temporaire
                // },
                file: null,
            
                color : '#f8f1e0',
                size : 'containY', // 'cover' | 'containX' | 'containY'
                position: {"x":50,"y":50},
                transform: {"rotate":0,"scale":1}
                
            },
            stickers : {}
        }
    }
}


const draftTemplate = {
    "multipleImages":[],
    "multipleMedias":[],
    "activeMentionsAutoReplace":true,
    "activeHashtagsAutoAdd":true,
    "validMentions":[],
    "mentionsAdded":[],
    "hashtagsAdded":[],
    "activePrefixSuffix":false,
    "layers":[],
    "carrouselRatio":1,
    "instagramTexts":[],
    "instagramTextsUpdater":[],
    "storyLinkText":"",
    "snippetTitle":"",
    "snippet":null,
    "carouselOrderDragElement":null,
    "poll":{"question":"","options":["",""],"duration":604800},
    "templateManual":null,
    "instagramLinkPosition":{"x":160,"y":440,"color":0},
    "highlightInstagram":null,
    "instagramBackgroundColor":null,
    "sharedStoryUrl":"",
    "storySharedVisual":null,
    "screenshot":null,
    "videoReel":true,
    "videoReelFB":false,
    "videos":"{\"twitter\":null,\"facebook\":null,\"facebook_reel\":null,\"linkedin\":null,\"instagram\":null,\"instagram_reel\":null,\"story\":null}",
    "location":null,
    "userTags":null,
    "storyVideo":false,
    "pollStory":null,
    "sliderStory":null,
    "musicStory":null,
    "gifsStory":[],
    "mentionsWidget":[],
    "filename":null,
    "videoname":null,
    "validHashtags":[],
    "storyMultiple":[],
    "shareAfterPost":false,
    "storificationData":{"link":null},
    "storyShareToFacebook":false,
    "compressedImages":[],
    "tiktokOptions":"{\"comment_disabled\":false,\"duet_disabled\":true,\"stitch_disabled\":true,\"privacy_level\":\"SELF_ONLY\"}",
    "youtubeOptions":"{\"notifySubscribers\":true,\"madeForKids\":false,\"privacy_level\":\"public\",\"category\":\"22\",\"tag\":\"\",\"tags\":[],\"playlist\":null}",
    "log":["{\"user\":{\"id\":\"a79437f2-b92a-4213-909e-a267a7accfb3\",\"name\":\"Guilloux Clementooo\",\"email\":\"clement@mashup-web.com\",\"avatar\":\"https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/09kcdi7v6b9n-1530533447961.jpg\"},\"isDraft\":true,\"created_at\":\"2024-10-17T18:47:35+02:00\"}"],
    "typePost": "standard",
}

const listNetworkSort = ['facebook','instagram','linkedin','google','threads','twitter','tiktok','youtube','pinterest','telegram']

export { 
    maxFilesPerNetwork,
    formDataDefault,
    draftTemplate,
    listNetworkSort
};
  



